import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'semantic-ui-css/semantic.min.css'
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider ,Helmet } from 'react-helmet-async';
//import  Head from "./Head"
//import { Smagen } from './components/Smagen';
//import { renderToString } from 'react-dom/server';


import './index.scss';
const root = ReactDOM.createRoot(document.getElementById('root'));
//const helmetContext = {};

const rootElement = document.getElementById("root");
root.render(
  //<React.StrictMode>
    <App />
  // </React.StrictMode>
);



reportWebVitals();